import { type CartIntermediateEntryObject } from './CartIntermediateContextValue'

/* This function extracts the product ID from a cart entry object.
 * product is a union type that can be either a recommendation product, PimProductWithVariantsV1, PimProductV12, or PimProductV13.
 * If the product is undefined, it returns undefined.
 */
export const cartIntermediateAccessorGetProductIdFromCartEntry = ({
  cartIntermediateEntryObject,
}: {
  cartIntermediateEntryObject: CartIntermediateEntryObject | undefined
}): string | undefined => {
  if (!cartIntermediateEntryObject?.product) {
    return undefined
  }

  const { product } = cartIntermediateEntryObject

  return 'UID' in product ? product.UID : product.upid
}
